//#region src/redux/build/initial-state.ts
var initialState = {
	build: void 0,
	isPending: false,
	isRejected: false,
	errorMessage: ""
};
//#endregion
export { initialState };

//# sourceMappingURL=initial-state.js.map